import { createLegacyModule } from "./createLegacyModule";

const keys = [
  "gsa Actual payable",
  "gsa Buyer party",
  "gsa confirm",
  "gsa Consignee",
  "gsa Delivery date",
  "gsa Food detail",
  "gsa Freight",
  "gsa Grand total",
  "gsa Name",
  "gsa No",
  "gsa Order date",
  "gsa Order detail",
  "gsa Order No",
  "gsa Purchase order",
  "gsa Qty",
  "gsa remark",
  "gsa status",
  "gsa Subtotal",
  "gsa Supplier",
  "gsa Tel",
  "gsa Unit Price",
  "gsa UOM"
];

export default createLegacyModule(keys);
